import { render, staticRenderFns } from "./DocumentationContainer.vue?vue&type=template&id=c6c5239a&scoped=true"
import script from "./DocumentationContainer.vue?vue&type=script&lang=js"
export * from "./DocumentationContainer.vue?vue&type=script&lang=js"
import style0 from "./DocumentationContainer.vue?vue&type=style&index=0&id=c6c5239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5239a",
  null
  
)

export default component.exports